// extracted by mini-css-extract-plugin
export default {"cutout_color_accent_container":"Cutout_cutout_color_accent_container__MDZwj","color_strip":"Cutout_color_strip__Pa-o3","color_accent":"Cutout_color_accent__xk1Eu"};